
import { getDouyinInfo, validDouyin, validDouyin2 } from '@/zsm-api-new/douyin.js'
const state = {

}

const mutations = {

}

const actions = {

  // 判断知识库用户是否需要授权
  validDouyin2({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      validDouyin2(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 判断用户是否需要授权
  validDouyin({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      validDouyin(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取抖音基本信息
  getDouyinInfo({ commit }, id) {
    return new Promise((resolve, reject) => {
      getDouyinInfo(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
